import { isCurrentlyOnPublicDashboard } from 'helpers/dashboardHelpers';
import { useIsEssential, useUserHasRole } from 'hooks/client';
import { ADMIN, SUPPORT } from 'business/constants';
import {
    DashboardActionCategory,
    DashboardActionType,
    getArchivedActions,
    getEditActions,
    getOrganizeActions,
    getShareActions,
} from '../helpers/actions';

/**
 * Returns the list of actions that can be performed on a dashboard group by category
 * @param {boolean} canEdit - Whether the user can edit the dashboard
 * @param {boolean} isHeader - The dashboard edit menu can be displayed in the dashboard header and in the dashboard card with different actions
 * @param {boolean} allowMove - Whether the dashboard can be moved to another folder
 * @returns {Record<DashboardActionCategory, DashboardActionType[]>}
 */
export const usePossibleDashboardActions = (
    canEdit: boolean,
    isHeader: boolean,
    allowMove: boolean,
): Record<DashboardActionCategory, DashboardActionType[]> => {
    const hasEssential = useIsEssential();
    const userIsSupport = useUserHasRole(SUPPORT);
    const isPublicDashboard = isCurrentlyOnPublicDashboard();
    const isAdmin = useUserHasRole(ADMIN);

    const actions: Record<DashboardActionCategory, DashboardActionType[]> = {
        organize: getOrganizeActions(isPublicDashboard, allowMove, isAdmin),
        share: getShareActions(isPublicDashboard, canEdit, isHeader),
        edit: getEditActions(
            isHeader,
            canEdit,
            userIsSupport,
            hasEssential,
            isPublicDashboard,
        ),
        archive: getArchivedActions(
            canEdit,
            isPublicDashboard,
            userIsSupport,
            hasEssential,
        ),
    };
    return actions;
};
